var _rect, _text, _rect2, _circle, _text2, _text3, _rect3, _circle2, _text4, _text5, _rect4, _circle3, _text6, _text7, _rect5, _circle4, _text8, _text9, _rect6, _circle5, _text0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomDevelopmentWhatWeBuildCapabilityModelDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 720,
    height: 460,
    viewBox: "0 0 720 460",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Custom system capability model") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 718,
    height: 458,
    rx: 27,
    fill: "#020B1B",
    stroke: "#2B5A85"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 36,
    y: 42,
    fill: "#74BDFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 850,
    letterSpacing: 1.5
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 36,
    dy: 0
  }, "WHAT THE SYSTEM CAN BECOME"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 72,
    width: 306,
    height: 116,
    rx: 16,
    fill: "#0A1C34",
    fillOpacity: 1,
    stroke: "#294766"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 97,
    r: 7,
    fill: "#087CFF"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 102,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "Operational platforms")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 132,
    fill: "#AFC0D6",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 620,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 54,
    dy: 0
  }, "End-to-end systems for complex work"), /*#__PURE__*/React.createElement("tspan", {
    x: 54,
    dy: 16
  }, "across teams and locations."))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 72,
    width: 306,
    height: 116,
    rx: 16,
    fill: "#0A1C34",
    fillOpacity: 1,
    stroke: "#294766"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 402,
    cy: 97,
    r: 7,
    fill: "#FF2775"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 420,
    y: 102,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "Custom CRMs")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 396,
    y: 132,
    fill: "#AFC0D6",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 620,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 396,
    dy: 0
  }, "Purpose-built relationships, cases,"), /*#__PURE__*/React.createElement("tspan", {
    x: 396,
    dy: 16
  }, "opportunities and service workflows."))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 208,
    width: 306,
    height: 116,
    rx: 16,
    fill: "#0A1C34",
    fillOpacity: 1,
    stroke: "#294766"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 233,
    r: 7,
    fill: "#30D6A1"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 238,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "Intelligent workflows")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 268,
    fill: "#AFC0D6",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 620,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 54,
    dy: 0
  }, "Evidence capture, validation, routing,"), /*#__PURE__*/React.createElement("tspan", {
    x: 54,
    dy: 16
  }, "alerts and automated action."))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 208,
    width: 306,
    height: 116,
    rx: 16,
    fill: "#0A1C34",
    fillOpacity: 1,
    stroke: "#294766"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 402,
    cy: 233,
    r: 7,
    fill: "#F4B63D"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 420,
    y: 238,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "Decision and reporting systems")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 396,
    y: 268,
    fill: "#AFC0D6",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 620,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 396,
    dy: 0
  }, "Live visibility, analytical models and"), /*#__PURE__*/React.createElement("tspan", {
    x: 396,
    dy: 16
  }, "management control."))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 352,
    width: 648,
    height: 70,
    rx: 16,
    fill: "#10243E",
    stroke: "#2B5A85"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 387,
    r: 6,
    fill: "#30D6A1"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 85,
    y: 380,
    fill: "#FFFFFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 790,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 85,
    dy: 0
  }, "ONE CONNECTED OPERATING MODEL"), /*#__PURE__*/React.createElement("tspan", {
    x: 85,
    dy: 18
  }, "The form follows the operational need \u2014 not a pre-set software category."))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDevelopmentWhatWeBuildCapabilityModelDesktop);
export default __webpack_public_path__ + "static/media/custom-development-what-we-build-capability-model-desktop.d57150ee09999f2bcef146dbc0696e93.svg";
export { ForwardRef as ReactComponent };